module.exports = __webpack_public_path__ + "img/product-img-eight.bcf809e4.png";